import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { TextareaInput } from "../inputs/textarea-input"

interface TextareaFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof TextareaInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function TextareaField<T extends FieldValues>({ field, id, description, ...props }: TextareaFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <TextareaInput id={id} error={!!error} {...field} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  bio: string;
}

<FormField
  control={form.control}
  name="bio"
  render={({ field }) => (
    <TextareaField<FormData>
      field={field}
      id="bio"
      label="Biography"
      placeholder="Tell us about yourself"
      description="Tell us a bit about yourself and your background."
      rows={4}
    />
  )}
/>
*/
